module.exports = __webpack_public_path__ + "media/images/emblems/Niederhuenigen-coat_of_arms-7ab648097ab2462929fbf3c320fa6773.svg";